import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export interface DownloadPayload {
  uuid: string;
  container: string;
}

export function useDownloadMedia() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async (payload: DownloadPayload) => {
      const metaDataRes = await fetch(
        `${
          import.meta.env.VITE_API_URL
        }/media-metadata`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'POST',
          body: payload ? JSON.stringify(payload) : '',
        }
      );

      if (!metaDataRes.ok) {
        throw new Error('Failed to fetch media metadata');
      }

      const metadata = await metaDataRes.json();
      const filename = metadata.filename ?? 'dyta_download';
    
      const res = await fetch(
        `${
          import.meta.env.VITE_API_URL
        }/download-media`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'POST',
          body: payload ? JSON.stringify(payload) : '',
        }
      );

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
  });
}
